<template>
<div>
    <b-tabs fill>
        <b-tab title="DEVOLUÇÕES" class="m-0" active>
            <b-card class="border-top-0">
                <vDevolucaoAdmList />
            </b-card>
        </b-tab>
        <b-tab title="DEVOLUÇÕES SOLICITADAS" class="m-0">
            <b-card class="border-top-0 text-center">
                <h3>DEVOLUÇÕES SOLICITADAS</h3>
                <b-row class="mt-3">
                    <b-col>
                        <b-form-group label="Status:" label-for="filter-input" label-cols-sm="3" label-align-sm="right" label-size="sm" class="mb-0">
                            <b-form-select size="sm" :options="optionStatus" @change="loadData" v-model="status" />
                        </b-form-group>
                    </b-col>
                    <b-col >
                        <!-- <label>Lote</label>-->
                        <b-form-group label="Lote:" label-for="filter-input" label-cols-sm="3" label-align-sm="right" label-size="sm" class="mb-0">
                            <b-form-input size="sm" id="filter-input" type="number" v-model="lote" placeholder="Procurar Lote"></b-form-input>
                            <!--<b-input-group-append>
                                <b-button :disabled="!filter" @click="filter = ''">Limpar</b-button>
                            </b-input-group-append> -->
                            <!-- <b-form-input v-model="lote" /> -->
                        </b-form-group>
                        <b-form-group label="NF:" label-for="filter-input" label-cols-sm="3" label-align-sm="right" label-size="sm" class="mb-0">
                            <b-form-input size="sm" id="filter-input" type="number" v-model="nf" placeholder="Procurar NF"></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-button size="sm" variant="primary" @click="loadData"> Buscar </b-button>
                    </b-col>            
                </b-row>
                <div class="row mt-3">
                    <div class="col">
                        <b-table :items="dataComputed" :fields="colunas" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" hover striped bordered small :current-page="currentPage" :per-page="perPage" :busy="loading" stacked="md" show-empty :filter="filter" :filter-included-fields="filterOn" @filtered="onFiltered" empty-text="Nenhuma nota fiscal encontrada ...">
                            <template #table-busy>
                                <div class="text-center text-danger my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                    <strong>Carregando ...</strong>
                                </div>
                            </template>
                            <template #cell(id)="data">
                                <b-button v-b-modal.modal-center variant="primary" @click="show(data.item.id)"><i class="fas fa-eye"></i></b-button>
                            </template>
                            <template #cell(aproved)="data">
                                <div>
                                    <p class="m-0"><b>{{data.item.aproved}}</b></p>
                                </div>
                            </template>
                        </b-table>
                        <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" align="fill" size="sm" class="my-0"></b-pagination>
                    </div>
                </div>
            </b-card>
        </b-tab>
    </b-tabs>

    <!------------------------------------- MODAL DE DETALHAMENTO DE DEVOLUCAO -------------------------------------------->
    <!--<div class="modal fade" id="modal-Devolve" tabindex="-1" role="dialog"> -->
    <b-modal :title="`Devolução da Nota ${danfe.numero}`" v-model="openModal" centered size="xl">
        <ul class="text-danger">
            <li v-for="error in errors" :key="error">{{ error }}</li>
            <input type="hidden" v-model="danfe.danfe_id" />
        </ul>
        <div v-if="danfe.status == 'LIBERADO'">
            <div v-if="danfe.analise.length > 0">
                <h4>
                    Demostrativo da análise, mediante a solicitação de devolução.
                </h4>
                <br />
                <table class="table table-bordered table-condensed table-hover">
                    <thead>
                        <tr>
                            <th>Regras</th>
                            <th>% Multa</th>
                            <th>Quantidade</th>
                            <th>Media</th>
                            <th>NF. Vs Media</th>
                            <th>Taxa</th>
                            <th>Subtotal</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="an in danfe.analise" :key="an">
                            <td>{{ an.descricao }}</td>
                            <td>{{ an.multa }} %</td>
                            <td>{{ an.quantidade }}</td>
                            <td>
                                R$ {{ parseFloat(an.media).toLocaleString("pt-BR") }}
                            </td>
                            <td>
                                R$
                                {{ parseFloat(an.nf_x_media).toLocaleString("pt-BR") }}
                            </td>
                            <td>
                                R$ {{ parseFloat(an.taxa).toLocaleString("pt-BR") }}
                            </td>
                            <td>
                                R$ {{ parseFloat(an.total).toLocaleString("pt-BR") }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <br />
            <textarea v-model="danfe.obs" class="form-control" readonly></textarea>
        </div>
        <div v-if="danfe.status == 'ABERTO' || danfe.status != 'LIBERADO'">
            <div class="row">
                <div class="col-md-4">
                    <h5>Revendedora</h5>
                </div>
                <div class="col-md-6">
                    <span>{{ danfe.nome }}</span>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4">
                    <h5>Chave da Nota</h5>
                </div>
                <div class="col-md-6">
                    <span>{{ danfe.chave }}</span>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4">
                    <h5>Número da Nota</h5>
                </div>
                <div class="col-md-6">
                    <span>{{ danfe.numero }}</span>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <div class="form-group">
                        <label>Tipo Devolução:</label>
                        <select disabled class="form-control" v-model="danfe.tipo" id="tipo-devolve">
                            <option :value="1">Total</option>
                            <option :value="2">Parcial</option>
                            <option :value="3">Extravio</option>
                        </select>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label>Tipo de Frete:</label>
                        <select disabled class="form-control" v-model="danfe.frete" id="tipo-frete">
                            <option :value="1">Proprio</option>
                            <option :value="2">Coleta</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <div class="form-group">
                        <label>Justificativa:</label>
                        <textarea  disabled class="form-control" rows="2" cols="3" v-model="danfe.justificativa"></textarea>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <img v-if="files" :src="files" class="img-rounded vue-image" width="200" />
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="form-group" v-if="danfe.tipo == 2">
                    <table class="table table-responsive">
                        <thead>
                            <th>Selecione...</th>
                            <th>Produto</th>
                            <th>Descricao</th>
                            <th>Quantidade</th>
                        </thead>
                        <tbody>
                            <tr v-for="itens in danfe.itens" :key="itens">
                                <td>
                                    <input type="checkbox" v-model="itensDevolve" :value="itens.id" />
                                </td>
                                <td>
                                    {{ itens.produto }}
                                </td>
                                <td>
                                    {{ itens.descricao }}
                                </td>
                                <td>
                                    {{ itens.quantidade }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <template #modal-footer>
            <!--<span class="disabled" v-if="danfe.status == 'ABERTO'">
                    <b-button variant="primary" id="botao-salvar" @click="salvaAlteracao"><i class="fa fa-arrow-circle-right"></i> Alterar</b-button>
                </span> -->
            <!-- <span v-if="danfe.status == 'ABERTO'">
                    <button type="button" class="btn btn-warning" data-dismiss="modal" @click="encerrar(danfe.devolucao)">
                        <i class="fa fa-eraser"></i> Encerrar
                    </button>
                </span> -->
            <button type="button" v-if="danfe.status == 'AGUARDANDO APROVACAO' && (permissionApprove && permissionApprove.name == 'approve_returns')" class="btn btn-warning" data-dismiss="modal" @click="aprovarDevolucao()">
                Aprovar
            </button>
            <button type="button" class="btn btn-primary" data-dismiss="modal" @click="close()">
                Fechar
            </button>
        </template>
    </b-modal>
</div>
</template>

<script>
export default {
    data() {
        return {
            datePickerConfig: {
                format: "D/MM/YYYY",
                showClose: true,
            },
            permissionApprove: false,
            openModal: false,
            modalVisible: false,
            nf: "",
            search: "",
            loading: false,
            colunas: [{
                    key: "numero",
                    label: "Nota Fiscal"
                },
                {
                    key: "lote",
                    label: "Lote",
                    sortable: true
                },
                {
                    key: "status",
                    label: "Situação"
                },
                {
                    key: "revendedora",
                    label: "Revendedora"
                },
                {
                    key: "distribuidor",
                    label: "Distribuidor"
                },
                {
                    key: "aproved",
                    label: "Aprovado Por"
                },
                {
                    key: "data_devolucao",
                    label: "Dt. Devolução",
                    /*sortable: true,
                    formatter: (value) => {
                        return value ? moment(value).format("DD/MM/YYYY - HH:MM:SS") : "";
                    }*/
                },
                {
                    key: "id",
                    label: "Ver"
                }
            ],
            data: [],
            tipo: 0,
            frete: 0,
            files: [],
            danfe_id: 0,
            justificativa: "",
            revendedora_id: 0,
            itensDevolve: [],
            image: "",
            chave: 0,
            existeDevolucao: 0,
            totalSelecionados: 0,
            status: 'ABERTO',
            lote: '',
            optionStatus: [
                {
                    text: 'Todos',
                    value: ''
                },
                {
                    text: 'Aguardando Aprovação',
                    value: 'AGUARDANDO APROVACAO'
                },
                {
                    text: 'Aberto',
                    value: 'ABERTO'
                },
                {
                    text: 'Em análise',
                    value: 'EM ANALISE'
                },
                {
                    text: 'Liberado',
                    value: 'LIBERADO'
                },
                {
                    text: 'Enviado',
                    value: 'ENVIADO'
                },
                {
                    text: 'Recebido',
                    value: 'RECEBIDO'
                },
                {
                    text: 'Rejeitado',
                    value: 'REJEITADO'
                },
                {
                    text: 'Encerrado',
                    value: 'ENCERRADO'
                }
            ],
            enviar: [],
            danfe: {
                numero: 0,
                chave: 0,
                tipo: "",
                valor: "",
                itens: [],
                pedidos: 0,
                revendedora: 0,
            },
            errors: [],
            totalRows: 1,
            currentPage: 1,
            perPage: 20,
            filter: null,
            filterOn: ['lote'],
            sortBy: 'lote',
            sortDesc: false,
            sortDirection: 'desc',
        };
    },
    methods: {
        aprovarDevolucao(){
            var vm = this;
            let url = "/distribuidor/devolucao/aprovar/" + vm.danfe.devolucao;

            this.$swal({
                title: 'Realmente deseja aprovar a devolução da Nota Fiscal '+  vm.danfe.numero +'?',
                text: 'Esta ação não poderá ser revertida!',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Sim, Aprovar!',
                cancelButtonText: 'Não, cancelar!',
                showCloseButton: true,
                showLoaderOnConfirm: true
            }).then((result) => {
                if (result.value) {
                    axios.get(url).then(function (response) {
                        vm.loadData();
                        vm.openModal = !vm.openModal;
                        vm.$swal("OK", "Devolução aprovada com sucesso", "success");
                    }).catch(function (error) {
                        var errors = error.response.data.errors;
                        if (typeof errors == "object") {
                            console.log(errors);
                            alert(errors.join("\n"));
                        } else {
                            alert(errors);
                        }
                        $(".loading").hide();
                    });
                }
            })
        },
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length
            this.currentPage = 1
        },

        devolucoes() {
            window.location.href = "/adm/devolucao";
        },
        getAnexos(id) {
            let url = "/distribuidor/devolucao/anexo/" + id;
            axios.get(url).then((response) => {
                if (response.data) {
                    this.files = response.data;
                    console.log("resposta do anexo..." + response.data);
                }
            });
        },
        loadData() {
            this.data = [];
            var vm = this;
            var params = {
                lote: this.lote,
                nf: this.nf,
                status: this.status
            }
            vm.loading = true;
            axios
                .get("/adm/devolucao/listar", {
                    params: params
                })
                .then(function (response) {
                    vm.formatDataToTable(response.data.devolucoes);
                    vm.permissionApprove = response.data.permissions;
                    vm.loading = false;
                    vm.totalRows = vm.data.length
                })
                .catch(function (errors) {
                    vm.loading = false;
                    console.log(errors);
                    $(".loading").hide();
                });
        },
        formatDataToTable(dataLoaded) {
            var data = [];
            var pedido = {};

            dataLoaded.forEach(function (el, index) {
                let obj = {};

                obj.id = el.id;
                obj.danfe_id = el.danfe_id;
                obj.aproved = el.aproved_by ? el.aproved.name : "-";
                obj.numero = parseInt(el.danfe.numero);
                obj.lote = el.danfe.pedidos.lote.codigo;
                obj.revendedora = el.danfe.pedidos.revendedora.nome;
                obj.status = el.status;
                (obj.tipo_devolucao = el.tipo_devolucao),
                (obj.data = new Date(el.create_at).toLocaleString());
                obj.selectable = el.status == "ABERTO";
                obj.distribuidor = el.danfe.pedidos.lote.distribuidor.nome;
                obj.data_devolucao = new Date(el.updated_at).toLocaleString("pt-BR");

                data.push(obj);
            });

            this.data = data;
        },
        close() {
            var vm = this;
            vm.openModal = !vm.openModal;
        },

        show(danfe_id) {

            var vm = this;
            var ob1 = [];
            var itensSeleciona = [];
            var anexo = "";
            vm.openModal = true;
            $(".loading").show();
            axios
                .get("/distribuidor/devolucao/busca/" + danfe_id)
                .then(function (response) {
                    let revendedor = response.data;

                    revendedor.forEach(function (a, b) {
                        vm.danfe.nome = a.pedidos.revendedora.nome;
                        vm.danfe.numero = a.numero;
                        vm.danfe.chave = a.chave;
                        vm.danfe.aproved = a.aproved_by ? a.aproved.name : "-";
                        vm.danfe.titulo = a.titulo;
                        vm.danfe.revendedora = a.pedidos.revendedora_id;
                        vm.danfe.justificativa = a.devolucao.justificativa;
                        ob1 = a.itens;
                        vm.danfe_id = a.id;
                        vm.revendedora_id = a.pedidos.revendedora.id;
                        vm.chave = a.chave;
                        vm.danfe.devolucao = a.devolucao.id;
                        vm.danfe.status = a.devolucao.status;
                        vm.danfe.obs = a.devolucao.obs;
                        vm.danfe.anexo = a.devolucao.anexo;
                        vm.danfe.total = a.devolucao.total;
                        vm.danfe.analise = a.devolucao.analise;
                        anexo = a.devolucao.anexo;

                        if (a.devolucao.itens != null) {
                            itensSeleciona = a.devolucao.itens.split(",");
                            itensSeleciona.forEach(function (c) {
                                vm.markDevolucao(c);
                            });
                        }

                        let tpo = a.devolucao.tipo_devolucao;

                        if (tpo == "TOTAL") {
                            vm.danfe.tipo = 1;
                        } else if ("EXTRAVIO") {
                            vm.danfe.tipo = 3;
                        }else{
                            vm.danfe.tipo = 2;
                        }
                        let tpfrete = a.devolucao.frete;

                        if (tpfrete == "COLETA") {
                            vm.danfe.frete = 2;
                        } else {
                            vm.danfe.frete = 1;
                        }
                    });

                    if (anexo != "") {
                        vm.getAnexos(anexo);
                    }

                    ob1.forEach(function (c, d) {
                        let obj = {};
                        obj.produto = c.produto.codigo;
                        obj.descricao = c.produto.nome;
                        obj.quantidade = c.quantidade;
                        obj.danfe_id = c.danfe_id;
                        obj.id = c.id;
                        vm.danfe.itens.push(obj);
                    });

                    $(".loading").hide();
                    vm.openModal = true;
                    //$("#modal-Devolve").modal();

                    if (vm.existeDevolucao > 0) {
                        $("#botao-salvar").hide();
                    }
                })
                .catch(function (errors) {
                    console.log(errors);
                    $(".loading").hide();
                });
        },

        salvaAlteracao() {
            var vm = this;
            let url = "/distribuidor/devolucao/salva";
            var tp = "";
            if (vm.danfe.tipo == 1) {
                tp = "TOTAL";
            } else {
                tp = "PARCIAL";
            }
            let data = {
                id: vm.danfe.devolucao,
                justificativa: vm.danfe.justificativa,
                tipo: tp,
                frete: vm.danfe.frete,
                itens: vm.itensDevolve,
                revendedora_id: vm.danfe.revendedora,
            };
            axios
                .post(url, data)
                .then(function (response) {
                    console.log(response.data);
                    //window.location.href = '/distribuidor/devolucao/acompanhar';
                    vm.loadData();
                    vm.$swal("OK", "Devolução excluida com sucesso", "success");
                })
                .catch(function (error) {
                    var errors = error.response.data.errors;
                    if (typeof errors == "object") {
                        console.log(errors);
                        alert(errors.join("\n"));
                    } else {
                        alert(errors);
                    }
                    $(".loading").hide();
                });
        },
        markDevolucao(id) {
            var vm = this;
            var indices = [];
            var idx = vm.itensDevolve.indexOf(id);

            if (idx === -1) {
                vm.itensDevolve.push(id);
            } else {
                vm.itensDevolve.splice(idx);
            }
        },

        deleta(id) {
            var vm = this;
            if (vm.danfe.status != "ABERTO") {
                vm.$swal(
                    "OK",
                    "Esta devolução já está em andamento e não poderá ser deletada, apenas encerrada.",
                    "error"
                );
            }
            let url = "/distribuidor/devolucao/deletar/" + id;
            axios
                .get(url)
                .then(function (response) {
                    console.log(response.data);
                    //window.location.href = '/distribuidor/devolucao/acompanhar';
                    //vm.flash('Devolução excluida com sucesso','success')
                    vm.$swal("OK", "Devolução excluida com sucesso", "success");
                })
                .catch(function (error) {
                    var errors = error.response.data.errors;
                    if (typeof errors == "object") {
                        console.log(errors);
                        alert(errors.join("\n"));
                    } else {
                        alert(errors);
                    }
                    $(".loading").hide();
                });
        },
        encerrar(id) {
            var vm = this;
            let data = {
                id: id
            };
            let url = "/distribuidor/devolucao/encerrar/" + id;
            axios
                .get(url)
                .then(function (response) {
                    console.log(response.data);
                    //window.location.href = "/distribuidor/devolucao/acompanhar";
                    //vm.flash('Devolução encerrada com sucesso','success');
                    vm.loadData();
                    vm.$swal("OK", "Devolução encerrada com sucesso", "success");
                })
                .catch(function (error) {
                    var errors = error.response.data.errors;
                    if (typeof errors == "object") {
                        console.log(errors);
                        alert(errors.join("\n"));
                    } else {
                        alert(errors);
                    }
                    $(".loading").hide();
                });
        },
        changeSelecionados(checked, id) {
            let index = this.enviar.indexOf(id);
            if (checked) {
                if (index === -1) {
                    this.enviar.push(id);
                }
            } else {
                if (index > -1) {
                    this.enviar.splice(index, 1);
                }
            }
        },
        changeMarcarTodos(check) {
            if (!check) {
                this.enviar = [];
                return;
            }
            var vm = this;
            this.data.forEach(function (data) {
                if (
                    check &&
                    data.status === "ABERTO" &&
                    vm.enviar.indexOf(data.id) < 0
                ) {
                    vm.changeSelecionados(data.id);
                    vm.enviar.push(data.id);
                }
            });
        },
        EnviarDevolucao() {
            if (this.enviar.length == 0) {
                vm.$swal(
                    "OPs",
                    "Selecione ao menos uma devolução antes de enviar.",
                    "error"
                );
                return;
            }
            this.enviar.forEach(function (a) {
                let url = "/distribuidor/devolucao/enviar/" + a;
                axios
                    .get(url)
                    .then(function (response) {
                        console.log(response.data);
                        //window.location.href = '/distribuidor/devolucao/acompanhar';
                        vm.loadData();
                        vm.$swal("OK", "Devoluções enviada com sucesso", "success");
                    })
                    .catch(function (error) {
                        var errors = error.response.data.errors;
                        if (typeof errors == "object") {
                            console.log(errors);
                            alert(errors.join("\n"));
                        } else {
                            alert(errors);
                        }
                        $(".loading").hide();
                    });
            });
        },
    },
    computed: {
        /*sortOptions() {
            return this.colunas.lote
                .filter(f => f.sortable)
                .map(f => {
                    return {
                        text: f.label,
                        value: f.key
                    }
                })
        },*/

        filteredData() {
            return this.data.filter((item) => {
                return item.id.toLowerCase().indexOf(this.search.toLowerCase()) > -1;
            });
        },
        dataComputed() {
            return this.data;
        },
    },

    mounted() {
        this.loadData();
    },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/adm_devolucao/List.vue